import React, { Component } from 'react';
import Helmet from "react-helmet";
// import { inject, observer } from 'mobx-react';

import History from '../../components/account/history';

const HistoryPage = () => (
	<div className="account-index">
		<Helmet>
			<title>ИРМ - История счета</title>
		</Helmet>
		<History/>
	</div> 
)
export default HistoryPage;


// WEBPACK FOOTER //
// ./src/routes/account/history.js